<template>
  <div>
    <div
      class="wrapper step__value step__value--margin-bottom"
      :class="{ 'no-padding': isCompleted }"
      v-for="(value, key) in extrasList"
      :key="key"
    >         
      <div class="value" v-if="Object.keys(extrasList).length > 1">
        {{ getFormattedDate(key.split('|')[0]) }} to {{ getFormattedDate(key.split('|')[1]) }}
        <iconCampingCard v-if="key.split('|')[2] === 'choice'" class="cca-icon"></iconCampingCard>
      </div>                    
      <template>
        <div
          class="wrapper d-flex justify-content-between"
          :class="{ 'no-padding': isCompleted }"
          v-for="(extra, index) in value"
          :key="index"
        >
          <div
            class="label pr-3"
          >
          {{ extra.amount }} x {{ extra.name }}
          <span v-if="extra.extra_fields.billing_type.includes('per_day')">
            {{ extra.days === 1 ? $t('generic.labels.forDay', {days: extra.days}) : $t('generic.labels.forDays', {days: extra.days})}}
          </span>
          <span v-if="extra.extra_fields.billing_type.includes('per_night')">
            {{ extra.days === 1 ? $t('generic.labels.forNight', {days: extra.days}) : $t('generic.labels.forNights', {days: extra.days})}}
          </span>
        </div>
          <div class="label">
            <span v-if="extra.price !== 0">
            {{
              extra.price
                | currency(campground.currency, language.code)
            }}
            </span>
            <span class="label-type" v-else-if="extra.choice_price">
              {{ $t(`generic.labels.included`) }}
            </span>
            <span class="label-type" v-else>
              <span v-if="!extra.extra_fields.billing_type.includes('per_night') 
                && !extra.extra_fields.billing_type.includes('per_day')
                && !extra.extra_fields.billing_type.includes('once')">
                {{ $t(`generic.labels.${extra.extra_fields.billing_type}`) }}
              </span>
              <span v-else>
                {{ $t(`generic.labels.included`) }}
              </span>
            </span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import bookingDataMixin from '@/mixins/bookingDataMixin'
import { mapGetters } from 'vuex';
import iconCampingCard from '@/assets/icons/camping-card.svg'

export default {
  name: "CiMandatoryExtrasList",
  components: {
    iconCampingCard,
  },
  mixins: [bookingDataMixin],
  props: {
    extrasList: {
      type: Object,
      required: true,
    },
    currency: {
      type: Object,
      required: true,
    },
    language: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('booking', {
      dates: 'dates',
      isCompleted: 'isCompleted',
    }),
    ...mapGetters('campground', {
      countries: 'countries',
      campground: 'campground',
    }),
  },
};
</script>

<style lang="scss">
@import '../../assets//styles/summary-step';
</style>